import React, { useState, useEffect } from 'react';
import { Modal, Button, Alert, Row, Col, Spinner } from 'react-bootstrap';
import { FaCalculator, FaLock, FaTimes, FaMoneyBillWave, FaChartBar } from 'react-icons/fa';
import api from '../services/api';
import RestructuringModal from './RestructuringModal';


const EarlySettlementModal = ({ show, onHide, report, onUpdate }) => {
    const [step, setStep] = useState('details'); // 'details', 'calculation', 'confirmed'
    const [settlementData, setSettlementData] = useState(null);
    const [existingSettlement, setExistingSettlement] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // ŞİFRE SİSTEMİ STATE'LERİ
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [adminPassword, setAdminPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmationLoading, setConfirmationLoading] = useState(false);
    const [showRestructuringModal, setShowRestructuringModal] = useState(false);

    // Modal açıldığında state'i resetle
    useEffect(() => {
        if (show && report) {
            setStep('details'); // Her zaman finansman detayları ile başla
            setSettlementData(null);
            setError('');
            setShowConfirmation(false);
            setAdminPassword('');
            setPasswordError('');
            checkExistingSettlement();
        }
    }, [show, report]);

    // Mevcut settlement var mı kontrol et
    const checkExistingSettlement = async () => {
        try {
            const response = await api.get(`/early-settlements/report/${report._id}`);
            setExistingSettlement(response.data.settlement);
        } catch (error) {
            // 404 = settlement yok, normal durum
            setExistingSettlement(null);
        }
    };

    // Erken settlement hesapla
    const handleCalculate = async () => {
        try {
            setLoading(true);
            setError('');

            const response = await api.get(`/early-settlements/calculate/${report._id}`);

            if (response.data.success) {
                setSettlementData(response.data.calculation);
                console.log('🔥 BACKEND RESPONSE:', response.data.calculation);
                setStep('calculation'); // Hesaplama sayfasına geç
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Hesaplama sırasında hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const handleRestructuring = () => {
        setShowRestructuringModal(true);
    };

    // Settlement'ı onayla ve kaydet - İLK AŞAMA (Şifre Modal Aç)
    const handleConfirmRequest = () => {
        setShowConfirmation(true);
        setPasswordError('');
        setAdminPassword('');
    };

    // Settlement'ı onayla ve kaydet - İKİNCİ AŞAMA (Şifre ile Onay)
    const handleConfirm = async () => {
        try {
            setConfirmationLoading(true);
            setPasswordError('');

            console.log('🔥 FRONTEND: handleConfirm başladı');
            console.log('🔥 FRONTEND: reportId =', report._id);
            console.log('🔥 FRONTEND: settlementData =', settlementData);

            // Şifre kontrolü (şimdilik basit kontrol)
            if (adminPassword !== '123456') {
                setPasswordError('Yanlış admin şifresi!');
                return;
            }

            console.log('🔥 FRONTEND: API çağrısı yapılıyor...');
            const response = await api.post(`/early-settlements/confirm/${report._id}`, settlementData);
            console.log('🔥 FRONTEND: API yanıtı:', response);
            console.log('🔥 FRONTEND: Debug bilgisi:', response.data.debug);
            console.log('🔥 FRONTEND: Settlement:', response.data.settlement);

            if (response.data.success) {
                setExistingSettlement(response.data.settlement);
                setStep('confirmed'); // Onay sayfasına geç
                setShowConfirmation(false); // Şifre modalını kapat
                onUpdate && onUpdate();
            }
        } catch (error) {
            setPasswordError(error.response?.data?.message || 'Onaylama sırasında hata oluştu');
        } finally {
            setConfirmationLoading(false);
        }
    };

    // Şifre modalını kapat
    const handleCancelConfirmation = () => {
        setShowConfirmation(false);
        setAdminPassword('');
        setPasswordError('');
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0
        }).format(amount);
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('tr-TR');
    };

    //  Kalan Ana Para Hesapla (frontend'de PMT ile)
    const calculateRemainingPrincipal = () => {
        if (!report || !report.financialData) {
            return 0;
        }

        const loanAmount = report.financialData.loanAmount || 0;
        const monthlyRate = (report.financialData.interestRate || 0) / 100;
        const term = report.financialData.term || 1;
        const monthlyPayment = report.financialData.monthlyPayment || 0;

        // Ödenen taksit sayısını bul
        const paidCount = report.paymentPlan
            ? report.paymentPlan.filter(p => p.paymentStatus === 'paid' && !p.isRestructured).length
            : 0;

        if (paidCount === 0) {
            // Hiç ödeme yoksa başlangıç tutarı
            return loanAmount;
        }

        // PMT formülü ile kalan ana parayı hesapla
        let remainingPrincipal = loanAmount;

        for (let i = 0; i < paidCount; i++) {
            const interest = remainingPrincipal * monthlyRate;
            const principal = monthlyPayment - interest;
            remainingPrincipal -= principal;
        }

        return Math.max(0, remainingPrincipal); // Negatif olmasın
    };

    const getModalTitle = () => {
        switch (step) {
            case 'details':
                return (
                    <>
                        <FaChartBar className="text-info me-2" />
                        Finansman Detayları - {report?.customerData?.name}
                    </>
                );
            case 'calculation':
                return (
                    <>
                        <FaCalculator className="text-warning me-2" />
                        Erken Kapama Hesaplaması - {report?.customerData?.name}
                    </>
                );
            case 'confirmed':
                return (
                    <>
                        <FaMoneyBillWave className="text-success me-2" />
                        Erken Kapama Tamamlandı - {report?.customerData?.name}
                    </>
                );
            default:
                return 'Finansman İşlemleri';
        }
    };

    if (!report) return null;

    return (
        <>
            <Modal show={show} onHide={onHide} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {getModalTitle()}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {error && (
                        <Alert variant="danger" className="mb-3">
                            {error}
                        </Alert>
                    )}

                    {/* ADIM 1: FİNANSMAN DETAYLARI */}
                    {step === 'details' && (
                        <>
                            <Row className="mb-4">
                                <Col md={6}>
                                    <p><strong>Kredi Tutarı:</strong> {formatCurrency(report.financialData?.loanAmount || 0)}</p>
                                    <p><strong>Aylık Taksit:</strong> {formatCurrency(report.financialData?.monthlyPayment || 0)}</p>
                                    <p><strong>Toplam Ödeme:</strong> {formatCurrency(report.financialData?.totalPayment || 0)}</p>
                                </Col>
                                <Col md={6}>
                                    <p><strong>Vade:</strong> {report.financialData?.term} ay</p>
                                    <p><strong>Faiz Oranı:</strong> %{report.financialData?.interestRate}</p>
                                    <p><strong>Kalan Ana Para:</strong> {formatCurrency(calculateRemainingPrincipal())}</p>
                                </Col>
                            </Row>

                            {existingSettlement && (
                                <Alert variant="success" className="mb-3">
                                    <h6>✅ Bu rapor için erken kapama tamamlanmış:</h6>
                                    <p><strong>Tarih:</strong> {formatDate(existingSettlement.confirmationDate)}</p>
                                    <p><strong>Toplam Ödenen:</strong> {formatCurrency(existingSettlement.totalEarlyPayment)}</p>
                                </Alert>
                            )}

                            {!existingSettlement && (
                                <Row>
                                    <Col md={6} className="mb-2 mb-md-0">
                                        <Button
                                            variant="primary"
                                            size="lg"
                                            className="w-100"
                                            onClick={handleRestructuring}
                                        >
                                            🔄 Yapılandırma
                                        </Button>
                                    </Col>
                                    <Col md={6}>
                                        <Button
                                            variant="success"
                                            size="lg"
                                            className="w-100"
                                            onClick={handleCalculate}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner size="sm" animation="border" className="me-2" />
                                                    Hesaplanıyor...
                                                </>
                                            ) : (
                                                <>
                                                    <FaCalculator className="me-2" />
                                                    💰 Erken Kapama Hesapla
                                                </>
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}

                    {/* ADIM 2: HESAPLAMA SONUÇLARI - BLOK BLOK GÖSTER */}
                    {step === 'calculation' && settlementData && (
                        <>
                            <Row className="g-3">
                                {/* BLOK 1: TEMEL VERİLER */}
                                <Col md={6}>
                                    <div className="card border-primary h-100">
                                        <div className="card-header bg-primary text-white">
                                            <h6 className="mb-0">📊 TEMEL VERİLER</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row text-sm">
                                                <div className="col-7"><strong>Ödenen Taksit:</strong></div>
                                                <div className="col-5">{settlementData.paidInstallmentCount}/{settlementData.paidInstallmentCount + (settlementData.originalRemainingInstallments || settlementData.remainingInstallments)}</div>

                                                <div className="col-7"><strong>Kalan Taksit:</strong></div>
                                                <div className="col-5">{settlementData.remainingInstallments || settlementData.originalRemainingInstallments} adet</div>

                                                <div className="col-7"><strong>Aylık Faiz:</strong></div>
                                                <div className="col-5">%{settlementData.formulas?.erkenKapama?.monthlyRate || '0'}</div>

                                                <div className="col-7"><strong>Günlük Faiz:</strong></div>
                                                <div className="col-5">%{settlementData.formulas?.erkenKapama?.dailyRate || '0'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* BLOK 2: MEVCUT BORÇ DURUMU */}
                                <Col md={6}>
                                    <div className="card border-success h-100">
                                        <div className="card-header bg-success text-white">
                                            <h6 className="mb-0">💰 MEVCUT BORÇ DURUMU</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row text-sm">
                                                <div className="col-7"><strong>Kalan Ana Para:</strong></div>
                                                <div className="col-5">{formatCurrency(settlementData.remainingPrincipal)}</div>

                                                <div className="col-7"><strong>Kalan Faiz:</strong></div>
                                                <div className="col-5">{formatCurrency(settlementData.remainingInterest)}</div>

                                                <div className="col-7"><strong>Faiz Cezası (%10):</strong></div>
                                                <div className="col-5 text-warning"><strong>{formatCurrency(settlementData.interestPenalty)}</strong></div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* BLOK 3: GECİKME DURUMU */}
                                <Col md={6}>
                                    <div className={`card border-${settlementData.hasLatePenalty ? 'danger' : 'secondary'} h-100`}>
                                        <div className={`card-header bg-${settlementData.hasLatePenalty ? 'danger' : 'secondary'} text-white`}>
                                            <h6 className="mb-0">⏰ GECİKME DURUMU</h6>
                                        </div>
                                        <div className="card-body">
                                            {settlementData.hasLatePenalty ? (
                                                <div className="row text-sm">
                                                    <div className="col-7"><strong>Geciken Taksit:</strong></div>
                                                    <div className="col-5 text-danger">{settlementData.lateDetails?.overdueInstallments || 0} adet</div>

                                                    <div className="col-7"><strong>Gecikme Süresi:</strong></div>
                                                    <div className="col-5 text-danger">{settlementData.lateDetails?.totalOverdueDays || 0} gün</div>

                                                    <div className="col-7"><strong>Gecikme Cezası:</strong></div>
                                                    <div className="col-5 text-danger"><strong>{formatCurrency(settlementData.latePenalty)}</strong></div>
                                                </div>
                                            ) : (
                                                <div className="text-center text-success">
                                                    <i className="fa fa-check-circle fa-2x mb-2"></i><br />
                                                    <strong>Gecikme Yok</strong><br />
                                                    <small>Tüm ödemeler zamanında</small>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>

                                {/* BLOK 4: ERKEN KAPAMA BEDELİ */}
                                <Col md={6}>
                                    <div className="card border-info h-100">
                                        <div className="card-header bg-info text-white">
                                            <h6 className="mb-0">🏃‍♂️ ERKEN KAPAMA BEDELİ</h6>
                                        </div>
                                        <div className="card-body">
                                            {settlementData.hasEarlySettlementFee ? (
                                                <div className="row text-sm">
                                                    <div className="col-7"><strong>Son Ödeme:</strong></div>
                                                    <div className="col-5">{settlementData.earlyDetails?.lastPaymentDate || 'N/A'}</div>

                                                    <div className="col-7"><strong>Geçen Süre:</strong></div>
                                                    <div className="col-5 text-info">{settlementData.earlyDetails?.earlyDays || 0} gün</div>

                                                    <div className="col-12 mt-2"><small className="text-muted">
                                                        <strong>Formül:</strong> {settlementData.earlyDetails?.formula || 'N/A'}
                                                    </small></div>

                                                    <div className="col-7 mt-2"><strong>Erken Kapama Bedeli:</strong></div>
                                                    <div className="col-5 mt-2 text-info"><strong>{formatCurrency(settlementData.earlySettlementFee)}</strong></div>
                                                </div>
                                            ) : (
                                                <div className="text-center text-muted">
                                                    <i className="fa fa-clock fa-2x mb-2"></i><br />
                                                    <strong>Erken Kapama Yok</strong><br />
                                                    <small>Ek bedel uygulanmaz</small>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>

                                {/* BLOK 5: TOPLAM ÖDEME - TAM GENİŞLİK */}
                                <Col md={12}>
                                    <div className="card border-warning">
                                        <div className="card-header bg-warning text-dark">
                                            <h5 className="mb-0 text-center">🎯 TOPLAM ÖDEME TUTARI</h5>
                                        </div>
                                        <div className="card-body bg-light">
                                            <Row className="text-center">
                                                <Col>
                                                    <div className="d-flex justify-content-between py-2 border-bottom">
                                                        <span>Ana Para:</span>
                                                        <strong>{formatCurrency(settlementData.remainingPrincipal)}</strong>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-2 border-bottom">
                                                        <span>Kalan Faiz:</span>
                                                        <strong>{formatCurrency(settlementData.remainingInterest)}</strong>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-2 border-bottom">
                                                        <span>Faiz Cezası:</span>
                                                        <strong>{formatCurrency(settlementData.interestPenalty)}</strong>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-2 border-bottom">
                                                        <span>Gecikme Cezası:</span>
                                                        <strong>{formatCurrency(settlementData.latePenalty)}</strong>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-2 border-bottom">
                                                        <span>Erken Kapama Bedeli:</span>
                                                        <strong>{formatCurrency(settlementData.earlySettlementFee)}</strong>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-3 border-top bg-success text-white px-3 rounded">
                                                        <span><strong>TOPLAM ÖDENECEK:</strong></span>
                                                        <strong className="fs-4">{formatCurrency(settlementData.totalPayableAmount)}</strong>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* ADIM 3: ONAY TAMAMLANDI */}
                    {step === 'confirmed' && (
                        <Alert variant="success" className="text-center">
                            <h4>✅ Erken Kapama Tamamlandı!</h4>
                            <p>İşlem başarıyla kaydedildi ve müşteri bilgilendirildi.</p>
                        </Alert>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        <FaTimes className="me-2" />
                        Kapat
                    </Button>

                    {step === 'calculation' && (
                        <Button
                            variant="success"
                            onClick={handleConfirmRequest}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner size="sm" animation="border" className="me-2" />
                                    Onaylanıyor...
                                </>
                            ) : (
                                <>
                                    <FaLock className="me-2" />
                                    🔐 Onayla ve Kaydet
                                </>
                            )}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* ŞİFRE ONAY MODAL */}
            <Modal show={showConfirmation} onHide={handleCancelConfirmation} size="sm" centered>
                <Modal.Header closeButton className="bg-warning">
                    <Modal.Title>
                        <i className="fa fa-exclamation-triangle me-2"></i>
                        GÜVENLİK ONAYI
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div className="alert alert-danger">
                        <strong>⚠️ DİKKAT!</strong><br />
                        Bu işlem <strong>GERİ ALINAMAZ</strong>!<br />
                        Settlement veritabanına kalıcı olarak kaydedilecek.
                    </div>

                    <h5 className="text-dark mb-3">
                        Toplam: <span className="text-success">{settlementData && formatCurrency(settlementData.totalPayableAmount)}</span>
                    </h5>

                    <div className="mb-3">
                        <label className="form-label"><strong>Admin Şifrenizi Girin:</strong></label>
                        <input
                            type="password"
                            className={`form-control ${passwordError ? 'is-invalid' : ''}`}
                            placeholder="Admin şifresi (admin123)"
                            value={adminPassword}
                            onChange={(e) => setAdminPassword(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleConfirm()}
                            autoFocus
                        />
                        {passwordError && (
                            <div className="invalid-feedback">
                                {passwordError}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelConfirmation}>
                        <FaTimes className="me-2" />
                        İptal
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleConfirm}
                        disabled={!adminPassword || confirmationLoading}
                    >
                        {confirmationLoading ? (
                            <>
                                <Spinner size="sm" animation="border" className="me-2" />
                                Onaylanıyor...
                            </>
                        ) : (
                            <>
                                <FaLock className="me-2" />
                                🔐 EVET, ONAYLA
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
            <RestructuringModal
                show={showRestructuringModal}
                onHide={() => setShowRestructuringModal(false)}
                report={report}
                onUpdate={(updatedReport) => {
                    setShowRestructuringModal(false);
                    onUpdate && onUpdate(updatedReport);
                }}
            />
        </>
    );
};

export default EarlySettlementModal;